<template>
  <div id="container">
    <MenuLeft ref="menu" class="left" />
    <PrivacyPolicyDialog v-if="showPrivacy" />
      <router-view></router-view>
    <MenuRight ref="menuright" class="right" />
  </div>
</template>

<script>
import MenuLeft from './MenuLeft'
import MenuRight from './MenuRight'
import PrivacyPolicyDialog from '@/views/service/PrivacyPolicyDialog'
import { mapGetters, mapActions } from 'vuex'
import postMessage from '@/utils/postMessage'

export default {
  name: 'Full',
  data () {
    return {
    }
  },
  created () {
    window.addEventListener('message', this.receiveMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.receiveMessage)
  },
  methods: {
    ...mapActions([
      'goToNextPage',
      'goToPreviousPage'
    ]),
    receiveMessage (message) {
      var d = postMessage.receive(message)
      if (d.system === 'cdskole') {
        switch (d.type) {
          case 'set-page':
            if (d.data.page !== this.pageNumber) this.$router.push({ params: { pageNumber: d.data.page } })
            break
          case 'next-page':
            this.goToNextPage()
            break
          case 'previous-page':
            this.goToPreviousPage()
            break
        }
      }
    }
  },
  computed: {
    ...mapGetters(['leftMenuOpen', 'showPrivacy', 'numberOfPages', 'spread']),
    pageNumber () {
      return Number(this.$route.params.pageNumber)
    }
  },
  watch: {
    leftMenuOpen (newVal, oldVal) {
      var el = this.$el
      if (newVal) {
        el.classList.add('left-menu-open')
      } else {
        el.classList.remove('left-menu-open')
      }
    },
    pageNumber (val, preVal) {
      postMessage.send('set-page', {
        previousPage: preVal,
        page: val,
        spread: this.spread
      })

      postMessage.send('progress', {
        progress: val / this.numberOfPages
      })

      if (val >= this.numberOfPages || (this.spread && val >= this.numberOfPages - 1)) {
        postMessage.send('finish', null)
      }
    },
    numberOfPages (val) {
      postMessage.send('info', {
        pageCount: val,
        spread: this.spread
      })
    },
    spread (val) {
      postMessage.send('toggle-spread', {
        spread: val
      })
    }
  },
  components: {
    MenuLeft,
    MenuRight,
    PrivacyPolicyDialog
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue